import { fetchApi } from '../utils/fetchApi'

export const login = ({ params }) => fetchApi({
  body: params,
  path: '/loginBackoffice',
})
